import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
// import { DataSourcesService } from "./data-sources.service";
import { EssentialService } from './essential.service';
//import { DataSourceService } from '../shared-components';
@Injectable({
  providedIn: 'root'
})
export class HtmlDataService {

  htmlDataDatasourcesList = {};
  constructor(
    private essentialsService: EssentialService) {
  }

  invokeDataSource(inputParam, dataSourceId, queryParamObj = null, forceInvoke = false) {
    let Data = {};
    if (queryParamObj) {
      Data = this.formatRequestObj(inputParam, queryParamObj);
      forceInvoke = true; // If Data Is filtered Force Invoke
    }
    const target = Object.keys(this.htmlDataDatasourcesList).find(x => x == dataSourceId);
    if (target && this.htmlDataDatasourcesList[target].length > 1 && !forceInvoke) {
      return of(this.htmlDataDatasourcesList[target]);
    }

    if (Data)
      Object.assign(Data, { inputType: Object.keys(Data) });

    let url = `/ApiInvoker/Invoke/${dataSourceId}`;

    return this.essentialsService.postData(url, Data).pipe(
      tap((res: any) => {
        // res && Object.assign(this.htmlDataDatasourcesList, { [dataSourceId]: res })
        if (res) {
          Object.assign(this.htmlDataDatasourcesList, { [dataSourceId]: res })
        }
      }
      ))
  }

  formatRequestObj(inputParam, queryParamObj) {
    let Data = {};
    if (queryParamObj) {
      let keys = Object.keys(queryParamObj);
      keys.forEach(x => {
        var obj = inputParam.find(y => y.paramValue === x);
        if (obj) {
          var name = obj.paramName;
          Object.assign(Data, { [name]: queryParamObj[x] });
        }
      })
    }
    return Data;
  }

  filterDataSourceByDataId(inputParam, dataSourceId, queryParamObj) {
    return this.invokeDataSource(inputParam, dataSourceId, queryParamObj).pipe(
      map(res => {
        if (res) {
          let result = [];
          let Data = {};
          if (queryParamObj) {
            //incase query params keys exit in the response
            Data = queryParamObj;
            result = this.filterResponse(res,Data);
          }

          if (!result || result.length == 0) {
            Data = this.formatRequestObj(inputParam, queryParamObj);
            result = this.filterResponse(res,Data);
          }

          return result;
        }
      })
    )
  }

  filterResponse(res,Data){
    const keys = Object.keys(Data);
    return res.filter((r) => {
      let isFiltered = true;
      for (let key of keys) {
        if (r[key] != +Data[key]) {
          isFiltered = false;
          break;
        }
      }
      return isFiltered;
    });
  }

  resetHtmlDataList() {
    this.htmlDataDatasourcesList = {};
  }
}



